import React from 'react';
import { Link  } from "react-router-dom";
import { Utils } from '../../../Utils';
import i18n from '../../../i18n/i18n.js';

import './Html.css';

class Html extends React.Component {

  parent = null;
  
  constructor(props) {
    super(props);

    this.parent = typeof props.parent != 'undefine' ? props.parent : null;
    this.ws_data = typeof props.ws_data != 'undefine' ? props.ws_data : null;

    this.state = {};
  }

  render() {
    const {formData, formErrors} = this.parent.state;
    const parent = this.parent;
    const ws_data = this.ws_data;

    if(!ws_data || !ws_data.category_html){
      return null;
    }

    const isHidden = ws_data.category_html.trim().startsWith('<input type="hidden"') && !ws_data.category_html.includes('<div') && !ws_data.category_html.includes('<span') && !ws_data.category_html.includes('<p') && !ws_data.category_html.includes('<button') && !ws_data.category_html.includes('<a');

    return <div className="row" style={isHidden ? {display: 'none'} : {}}>
      <div 
        className={`field html ${ws_data.fieldname}`} 
        dangerouslySetInnerHTML={{__html: ws_data.category_html}}>
      </div>
    </div>;
  }
};

export default Html;
